import { render, staticRenderFns } from "./SpecialInspectsEdit.vue?vue&type=template&id=0c15b90c&"
import script from "./SpecialInspectsEdit.vue?vue&type=script&lang=js&"
export * from "./SpecialInspectsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpecialInspectsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports